<template>
  <!-- 评价 -->
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ evaluate.Name }}</p>
      <!-- {{ pjdata }} -->
    </div>
    <!-- <div v-if="!evaluate" class="bottom_content">
      <div class="add">
        <div class="startPj">
          <div v-for="d in evaluate" :key="d.DimensionId" class="myd">
            <p>{{ d.DimensionName }}</p>
            <van-rate v-model="d.Star" color="#ECB57C" />
          </div>
        </div>
        <div class="btom_box">
          <div class="textarea_box">
            <van-field
              v-model="form.text"
              autosize
              label=""
              :left-icon="bjImg"
              placeholder="写评价"
              readonly
              rows="3"
              size="40px"
              type="textarea"
            />
          </div>
          <div
            class="resources-box"
            style="margin-bottom: -6px; padding: 10px 10px 20px 10px"
          >
            <div>
              <zy-uploader
                v-model:file="form.imageList"
                disabled
                :limit-size="500 * 1024"
                :max-count="9"
                :max-size="10 * 1024 * 1024"
                preview-size="60"
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 无服务评价 -->
    <div class="bottom_content">
      <div class="add">
        <div class="startPj">
          <div v-for="(e, i) in evaluate.Comments" :key="i + 'pk'" class="myd">
            <p>{{ e.DimensionName }}</p>
            <van-rate
              v-model="e.Star"
              color="#ECB57C"
              :readonly="
                evaluate.HasComment || state2 != '10' || nodestatus == '30'
              "
              @change="onChange(e.DimensionId, e.Star, i)"
            />
          </div>
        </div>
        <div class="btom_box">
          <div v-if="WithWords" class="textarea_box">
            <!-- <img v-if="!inputBlur" alt="" src="@/assets/images/bj.png" /> -->
            <van-field
              v-if="
                !evaluate.HasComment && state2 == '10' && nodestatus == '20'
              "
              v-model="evaluate.Content"
              label=""
              placeholder="写评价"
              :readonly="
                state2 != '10' || nodestatus == '30' || evaluate.HasComment
              "
              rows="3"
              size="40px"
              type="textarea"
            />
            <p
              v-else
              class="ywc_text"
              v-html="hhText(evaluate.Content + '')"
            ></p>
            <!--:readonly="!pjdata.WithWords"-->
          </div>

          <div class="resources-box">
            <div v-if="WithPicture && state2 == '10' && nodestatus == '20'">
              <zy-uploader
                v-if="!evaluate.HasComment"
                v-model:file="form.imageList"
                :disabled="
                  state2 != '10' || nodestatus == '30' || evaluate.HasComment
                "
                :limit-size="500 * 1024"
                :max-count="9"
                :max-size="10 * 1024 * 1024"
                preview-size="60"
                @imgList="getImgList"
              />
            </div>
            <!-- :disabled="!pjdata.WithPicture"-->
            <!-- <span v-if="!evaluate.HasComment" class="ts">
              上传图片,让更多人看到你的成就
            </span> -->
            <div class="ywc_img">
              <img
                v-for="(g, i) in evaluate.Pictures"
                :key="i + 'm'"
                alt=""
                lazy-load
                :src="api.FileHost + g"
                :style="{ 'object-fit': 'cover' }"
                @click.stop="showImg(evaluate.Pictures, i)"
              />
            </div>
          </div>
        </div>
        <div
          v-if="!evaluate.HasComment && state2 == '10' && nodestatus == '20'"
          class="btnSave"
          @click="
            submit(
              evaluate.ModuleInstanceId,
              evaluate.Comments,
              evaluate.Content,
              evaluate
            )
          "
        >
          发表评价
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'
  import { hhText } from '@/utils/index'
  import ZyUploader from '@/components/ZyUploadertjpj'
  //import ZyVideoUploader from '@/components/ZyVideoUploader'
  import store from '@/store'
  import { useRouter, useRoute } from 'vue-router'
  import { router, watch, onMounted, onBeforeUnmount } from 'vue'
  import { Toast, Dialog, ImagePreview } from 'vant'
  import storage from '@/utils/storage'
  import api from '@/api'
  export default {
    components: {
      ZyUploader,
      //ZyVideoUploader,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop
      evaluate: {
        type: Object,
      },
      // eslint-disable-next-line vue/require-default-prop
      pjdata: {
        type: Object,
      },
      // eslint-disable-next-line vue/require-default-prop
      state2: {
        type: Number,
      },
      // eslint-disable-next-line vue/require-default-prop
      nodestatus: {
        type: Number,
      },
    },
    setup(props) {
      const showTopic = ref(false)
      const bjImg = ref(require('../../../assets/images/bj.png'))
      const active = ref(1)
      const loading = ref(true)
      const WithWords = ref(null) //文字控制
      const WithPicture = ref(null) //图片控制
      const topicList = ref([])
      const router = useRouter()
      const route = useRoute()
      const pjCanshu = ref({
        moduleInstanceId: 0,
        content: '',
        pictures: [],
        comments: [],
      })
      const form = ref({
        id: null,
        title: '',
        text: '',
        imageList: '',
        topicId: '',
        topicName: '',
        image: [],
        video: [],
        videoList: '',
        audio: [],
        myd: 0,
        zyd: 0,
      })
      onMounted(() => {
        getList(props)
        pjCanshu.value.content = props.evaluate.Content
      })
      const submitLoading = ref(false)
      // get id 有id时为编辑
      // const getDetail = (id) => {
      //   store
      //     .dispatch('case/PostGet', {
      //       id,
      //     })
      //     .then(async (data) => {
      //       const Data = data.Data
      //       form.value.id = Data.Id
      //       form.value.title = Data.Title
      //       form.value.text = Data.Text
      //       await getTopicList()
      //       topicList.value.forEach((item) => {
      //         if (item.TagId === Data.TopicId) {
      //           form.value.topicName = item.TagLabel
      //         }
      //       })
      //       form.value.topicId = Data.TopicId
      //       form.value.imageList = Data.Image.join(',')
      //       form.value.videoList = Data.Video.join(',')
      //     })
      //     .catch((e) => {
      //       Toast.fail('获取帖子详情失败')
      //     })
      // }
      // 提交评价
      const getComment = (id, content, evaluate) => {
        const params = pjCanshu.value
        params.moduleInstanceId = id
        params.content = content
        params.formId = route.params.id
        //console.log('pjCanshu.value :>> ', pjCanshu.value)
        store
          .dispatch('service/Comment', params)
          .then((data) => {
            const { Data } = data
            Toast('评价成功')
            evaluate.HasComment = true
            evaluate.Pictures = params.pictures
          })
          .catch((e) => {
            Toast.fail(e.Message || '提交失败')
          })
      }

      const onChange = (id, value, i) => {
        pjCanshu.value.comments[i] = {
          star: value,
          dimensionId: id + '',
        }
        //pjCanshu.value.comments[i].star = value
        //console.log('pjCanshu.value.comments :>> ', pjCanshu.value.comments)
      }

      const getImgList = (val) => {
        //console.log('val :>> ', val)
        pjCanshu.value.pictures = []
        val.map((item, index) => {
          //console.log('item,,,, :>> ', item)
          pjCanshu.value.pictures.push(item.deliveryUrl)
        })

        //console.log('valimg :>> ', pjCanshu.value.pictures)
      }
      // const id = route.query.id
      // if (id) {
      //   getDetail(id)
      // }
      // onMounted(() => {
      //   //getCase()
      //   const cased = JSON.parse(storage.get('case')) || ''
      //   Object.assign(form.value, cased)
      //   console.log('onMounted')
      //   document.getElementById('editor').addEventListener('paste', eventPaste)
      // })

      // onBeforeUnmount(() => {
      //   console.log('onBeforeUnmount')
      //   document
      //     .getElementById('editor')
      //     .removeEventListener('paste', eventPaste)
      // })
      //图片预览
      const showImg = (list, index) => {
        const arr = []
        list.forEach((item) => {
          arr.push(api.FileHost + item)
        })
        ImagePreview({
          images: arr,
          startPosition: index,
          showIndex: false,
          showIndicators: true,
          overlayStyle: {
            background: '#000',
          },
          //closeable: true,
        })
      }
      // const eventPaste = (e) => {
      //   if (e.clipboardData) {
      //     // 阻止默认行为
      //     e.preventDefault()
      //     var clipboardData = e.clipboardData
      //     // 获取剪贴板的文本
      //     var text = clipboardData.getData('text')
      //     if (window.getSelection && text !== '' && text !== null) {
      //       // 创建文本节点
      //       var textNode = document.createTextNode(text)
      //       // 在当前的光标处插入文本节点
      //       var range = window.getSelection().getRangeAt(0)
      //       // 删除选中文本
      //       range.deleteContents()
      //       // 插入文本
      //       range.insertNode(textNode)
      //     }
      //   }
      // }
      // 保存案例内容
      // watch(
      //   form,
      //   (newVal, oldVal) => {
      //     saveCase()
      //   },
      //   {
      //     deep: true,
      //   }
      // )

      // const saveCase = () => {
      //   storage.set('case', JSON.stringify(form.value))
      // }

      const contentBlur = ($event) => {
        setTimeout(() => {
          form.value.text = $event.target.innerHTML
        })
      }

      // const removeCase = () => {
      //   storage.remove('case')
      // }

      // // 点击选择话题时加载话题数据
      // const showTopicHandle = () => {
      //   showTopic.value = true
      //   if (!topicList.value.length) {
      //     getTopicList()
      //   }
      // }
      // // 下拉选择话题
      // const selectTopic = (item) => {
      //   form.value.topicId = item.TagId
      //   form.value.topicName = item.TagLabel
      //   showTopic.value = false
      // }

      // // 获取话题
      // const getTopicList = async () => {
      //   const params = {
      //     TenantId: (await store.getters['user/getTenant']).TenantId,
      //     pageIndex: 1,
      //     pageSize: 20,
      //     tagLabel: '',
      //     isHotTag: -1,
      //   }
      //   return store
      //     .dispatch('case/TopicTagGetList', params)
      //     .then((data) => {
      //       loading.value = false
      //       topicList.value = data.Data.CurrentPage
      //     })
      //     .catch((e) => {
      //       loading.value = false
      //       //console.log(e)
      //     })
      // }

      const cancel = () => {
        router.back()
      }
      const getList = async () => {
        let TenantId = (await store.getters['user/getTenant']).TenantId
        store
          .dispatch('service/GetList', { TenantId: TenantId })
          .then((data) => {
            //console.log('data :>> ', data)
            WithWords.value = data.Data.WithWords
            WithPicture.value = data.Data.WithPicture
          })
          .catch((e) => {
            //console.log(e)
          })
      }
      const submit = async (id, comments, content, evaluate) => {
        //console.log('comments :>> ', comments)
        if (submitLoading.value) return
        let name = []
        comments.map((item, index) => {
          //console.log('item :>> ', item)
          if (item.Star === 0) {
            name.push('[ ' + item.DimensionName + ' ]')
          }
        })

        if (name.length > 0) {
          Toast(`${name.join(',')}维度不能为空`)
        } else {
          getComment(id, content, evaluate)
        }

        //getComment(id)
        // if (!pjCanshu.value.content) {
        //   Toast('请输入评价~~')
        //   return
        // }

        // if (!form.value.topicId) {
        //   Toast('请选择标签!')
        //   return
        // }
        // if (form.value.imageList.length) {
        //   form.value.image = form.value.imageList.split(',')
        // }
        // if (form.value.videoList.length) {
        //   form.value.video = form.value.videoList.split(',')
        // }
        // form.value.tenantId = (await store.getters['user/getTenant']).TenantId
        // form.value.industry = store.getters['user/getIndustry']
        // submitLoading.value = true
        // let url = 'case/PostPublish'
        // if (form.value.id) {
        //   url = 'case/PostUpdate'
        // }
        // store
        //   .dispatch(url, form.value)
        //   .then((data) => {
        //     Toast.success('发表成功')
        //     removeCase()
        //     setTimeout(() => {
        //       submitLoading.value = false
        //       router.replace({
        //         name: 'Mypost',
        //       })
        //     }, 1000)
        //   })
        //   .catch((e) => {
        //     const msg = e.Message || '操作失败'
        //     Toast.error(msg)
        //     submitLoading.value = false
        //     console.log(e)
        //   })
      }
      return {
        form,
        showTopic,
        active,
        //showTopicHandle,
        loading,
        topicList,
        //selectTopic,
        cancel,
        submit,
        submitLoading,
        contentBlur,
        bjImg,
        onChange,
        pjCanshu,
        getImgList,
        api,
        showImg,
        //getList,
        WithWords,
        WithPicture,
        hhText,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .textarea_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    img {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 9px;
      left: 11px;
      z-index: 999;
    }
  }
  .van-uploader >>> .van-uploader__upload {
    border: 1px solid #cbccce !important;
    border-radius: 12px !important;
    overflow: hidden;
  }
  .ywc_text {
    font-size: 14px;
    color: #888;
    margin: 5px 0 0 0;
  }
  .ywc_img {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    img {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      margin-bottom: 10px;
      border: 1px solid #eee;
    }
  }
  .list_box {
    .btn {
      width: 100%;
      height: 32px;
      background-color: #b57e48;
      border-radius: 4px;
      text-align: center;
      line-height: 32px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      padding: 15px 0;
    }
  }
  .ts {
    font-size: 12px;
    color: #ccc;
    padding-bottom: 20px;
  }
  .btn-list {
    li {
      text-align: center;
      line-height: 1;
      color: #666;
      padding: 0 8px;
      margin-right: 10px;
      i {
        font-size: 24px;
      }
      p {
        color: #333;
        font-size: 14px;
        margin: 6px 0 0;
      }
      &.current {
        color: #1989fa;
        p {
          color: #1989fa;
        }
      }
    }
  }
  .btn-box {
    background: #fff;
    padding: 16px;
    .cancel {
      width: 26%;
      padding-right: 10px;
    }
    &.fixed {
      position: fixed;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
  .topic-content {
    //min-height: 200px;
    .content ul {
      padding: 20px 20px;
      li {
        margin: 10px 16px;
        a {
          color: #666;
          &.current {
            color: #1989fa;
          }
        }
      }
    }
    .btn-box {
      padding: 10px 16px;
    }
  }
  .loading-box {
    text-align: center;
    padding: 50px;
  }
  .resources-box {
    background-color: #fff;
    div + div {
      margin: 10px 0 0;
    }
  }
  .no-data {
    padding-bottom: 10px;
    color: #666;
    font-size: 14px;
  }
  .edit {
    &:empty:before {
      content: '请输入正文';
      color: #ccc;
    }
    &:focus:before {
      content: none;
    }
  }
  .startPj {
    .myd,
    .zyd {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      p {
        margin-right: 10px;
        margin-left: 4px;
        font-size: 14px;
        color: #4f515f;
      }
    }
    .myd {
      margin-bottom: 10px;
    }
  }
  .btom_box {
    background: #fff;
    //border-radius: 18px;
    overflow: hidden;
    margin-top: 18px;
  }
  .bottom_content {
    padding: 20px 15px;
  }
  .add {
    .btnSave {
      width: 100%;
      height: 40px;
      background-color: #b57e48;
      border-radius: 4px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      color: #ffffff;
      margin-top: 15px;
    }
  }
</style>
